import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const WEBAUTHN_BASE_URL =
	process.env.REACT_APP_WEBAUTHN_API_URL ||
	"https://dev.softsprint.ae/MaintBackend/api/v1";

/**
 * test
 * WebAuthn API – security key registration and authentication.
 *
 * Setting key (1st time or sign up):
 * - webauthnRegisterStart → no input, returns challengeId
 * - user touches fingerprint → credential from browser
 * - webauthnRegisterComplete → { challengeId, credential }
 *
 * Logging in with existing key:
 * - webauthnAuthenticateStart → { email }, returns webauthn status + challengeId
 * - user touches fingerprint → credential from browser
 * - webauthnAuthenticateComplete → { challengeId, credential }
 */
export const WebAuthnApi = createApi({
	reducerPath: "WebAuthn",
	baseQuery: fetchBaseQuery({
		baseUrl: WEBAUTHN_BASE_URL,
		prepareHeaders: (headers) => {
			headers.set("Content-Type", "application/json");
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
		credentials: "include",
	}),
	endpoints: (builder) => ({
		// --- Setting key (1st time or sign up) ---
		webauthnRegisterStart: builder.mutation({
			query: () => ({
				url: "/webauthn/register/start",
				method: "POST",
				body: {},
			}),
		}),
		webauthnRegisterComplete: builder.mutation({
			query: (body) => ({
				url: "/webauthn/register/complete",
				method: "POST",
				body: {
					challengeId: body.challengeId,
					credential: body.credential,
				},
			}),
		}),

		// --- Logging in with existing key ---
		webauthnAuthenticateStart: builder.mutation({
			query: (body) => ({
				url: "/webauthn/authenticate/start",
				method: "POST",
				body: {
					email: body.email,
				},
			}),
		}),
		webauthnAuthenticateComplete: builder.mutation({
			query: (body) => ({
				url: "/webauthn/authenticate/complete",
				method: "POST",
				body: {
					challengeId: body.challengeId,
					credential: body.credential,
				},
			}),
		}),
	}),
});

export const {
	useWebauthnRegisterStartMutation,
	useWebauthnRegisterCompleteMutation,
	useWebauthnAuthenticateStartMutation,
	useWebauthnAuthenticateCompleteMutation,
} = WebAuthnApi;
